export default [
  {
    path: "/h5/index",
    name: "h5-index",
    component: () => import('@/pages/v2/h5/home'),
  },
  {
    path: "/h5/app-download",
    name: "h5-app-download",
    component: () => import('@/pages/v2/download/app-download-h5'),
  },
  {
    path: "/h5/merchandiser",
    name: "h5-merchandiser",
    component: () => import('@/pages/v2/h5/follower'),
  },
]



// WEBPACK FOOTER //
// ./src/router/v2/h5/home/index.js